import classNames from 'classnames';
import styles from './ratingStars.module.scss';

const RatingStars = ({ rating, max, starSize, starSizeMobile, className }) => {
  const stars = [];

  for (let i = 0; i < max; i++) {
    const fillPercentage = Math.max(0, Math.min(1, rating - i));

    stars.push(
      <div key={i} className={styles.starIcon}>
        {/* Empty star background */}
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="#CCCCCC"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M7 0L8.65248 5.34752H14L9.67376 8.65248L11.3262 14L7 10.695L2.67376 14L4.32624 8.65248L0 5.34752H5.34752L7 0Z" />
        </svg>

        {/* Filled star overlay */}
        <div className={styles.starFill} style={{ width: `${fillPercentage * 100}%` }}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 0L8.65248 5.34752H14L9.67376 8.65248L11.3262 14L7 10.695L2.67376 14L4.32624 8.65248L0 5.34752H5.34752L7 0Z"
              fill="black"
            />
          </svg>
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames(styles.starsContainer, className)}
      style={{ '--star-size': starSize, '--star-size-mobile': starSizeMobile }}
    >
      {stars}
    </div>
  );
};

export default RatingStars;
